import { render, staticRenderFns } from "./DealCalculatorView.vue?vue&type=template&id=2064bb87&scoped=true&"
import script from "./DealCalculatorView.vue?vue&type=script&lang=js&"
export * from "./DealCalculatorView.vue?vue&type=script&lang=js&"
import style0 from "./DealCalculatorView.vue?vue&type=style&index=0&id=2064bb87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064bb87",
  null
  
)

export default component.exports